
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkySheet as SkySheetElement } from '@sky.ui/core/sky-sheet';
 
 
 
 

 
 export const SkySheet = createComponent({
   displayName: 'SkySheet',
   react: React,
   tagName: 'sky-sheet',
   elementClass: SkySheetElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-sheet';
